import { Card, CardContent, CardHeader, CardTitle } from "../../../../../components/ui/card";
import { Button } from "../../../../../components/ui/button";
import { OperationConfirmDialog } from "../../../../../components/ui/operation-confirm-dialog";
import { useState } from "react";
import { BaixaItem } from "../types";
import { BaixaStatCard } from "./baixa-stat-card";
import { DollarSign, FileText, Database } from "lucide-react";

interface BaixaItemCardProps {
  baixaItem: BaixaItem;
  ops: string;
  onStartDoc: (filterDate: string, ops: string) => void;
  onSubmitDb: (filterDate: string, ops: string) => void;
  isStartingDoc: boolean;
  isSubmittingDb: boolean;
}

export function BaixaItemCard({
  baixaItem,
  ops,
  onStartDoc,
  onSubmitDb,
  isStartingDoc,
  isSubmittingDb,
}: BaixaItemCardProps) {
  const [openStartDoc, setOpenStartDoc] = useState(false);
  const [openSubmitDb, setOpenSubmitDb] = useState(false);

  const filterDate = baixaItem.data_vencimento.slice(0, 10);
  const isDatePassed = new Date() > new Date(baixaItem.data_vencimento);

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value / 100);
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg">
            Data Vencimento: {filterDate}
          </CardTitle>
          <div className="flex gap-2">
            <Button
              size="sm"
              variant="outline"
              onClick={() => setOpenStartDoc(true)}
              disabled={isStartingDoc}
            >
              <FileText className="mr-2 h-4 w-4" />
              Criar CNAB
            </Button>
            <Button
              size="sm"
              onClick={() => setOpenSubmitDb(true)}
              disabled={!isDatePassed || isSubmittingDb}
            >
              <Database className="mr-2 h-4 w-4" />
              Realizar Baixa
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          <BaixaStatCard
            title="Ops"
            value={ops.toUpperCase()}
            icon={<DollarSign className="h-6 w-6" />}
          />
          <BaixaStatCard
            title="Valor Face Bônus"
            value={formatCurrency(baixaItem.valor_face_bonus)}
            icon={<DollarSign className="h-6 w-6" />}
          />
          <BaixaStatCard
            title="Valor de Face"
            value={formatCurrency(baixaItem.valor_face)}
            icon={<DollarSign className="h-6 w-6" />}
          />
          <BaixaStatCard
            title="Deságio Bônus"
            value={formatCurrency(baixaItem.desagio_bonus)}
            icon={<DollarSign className="h-6 w-6" />}
          />
          <BaixaStatCard
            title="Deságio"
            value={formatCurrency(baixaItem.desagio)}
            icon={<DollarSign className="h-6 w-6" />}
          />
        </div>
      </CardContent>

      <OperationConfirmDialog
        open={openStartDoc}
        onOpenChange={setOpenStartDoc}
        onConfirm={() => onStartDoc(filterDate, ops)}
        action="baixa"
        ops={ops}
        date={filterDate}
        details={[{ label: "Etapa", value: "Criar CNAB de baixa" }]}
      />

      <OperationConfirmDialog
        open={openSubmitDb}
        onOpenChange={setOpenSubmitDb}
        onConfirm={() => onSubmitDb(filterDate, ops)}
        action="baixa"
        ops={ops}
        date={filterDate}
        details={[{ label: "Etapa", value: "Realizar baixa no banco de dados" }]}
      />
    </Card>
  );
}
